import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { UtilService } from './util.service';

@Injectable({
  providedIn: "root"
})
export class DeclaracaoAnualService {

  constructor(private http: HttpClient, private util: UtilService) {

  }

  public listarAnos(){

    return this.http
                .get(`${environment.apiURL}/Logado/DeclaracaoAnual/ListarAnos`);
  }

  public gerarPDF(ano: number){

    return this.http
               .get(`${environment.apiURL}/Logado/DeclaracaoAnual/GerarPDF?ano=${ano}`, {responseType: "blob"})
  }

}
